export const AUTH_SER = '/vpubtp/user';
export const AUTH_OTP = `${AUTH_SER}/auth/otp-request`;
export const AUTH_LOGIN_OTP = `${AUTH_SER}/auth/login-with-otp`;

export const USER_SER = '/user-service/api/v1';
export const USER_BATCH = `${USER_SER}/users/batch`;
export const USER_ME = `${USER_SER}/users/me`;
export const USER_SEARCH = `${USER_SER}/users/search`;
export const FCM_TOKENS = `${USER_SER}/fcm-tokens`;

export const MESSAGE_SER = '/message-service/api/v1';

export const CONVERSATION = `${MESSAGE_SER}/conversations`;
export const CONVERSATION_ITEM = `${CONVERSATION}/:conversationId`;
export const CONVERSATION_ITEM_LEAVE = `${CONVERSATION_ITEM}/leave`;
export const CONVERSATION_ITEM_MEMBER = `${CONVERSATION_ITEM}/members`;
export const CONVERSATION_ITEM_MARKER = `${CONVERSATION_ITEM}/read-marker`;
export const CONVERSATION_ITEM_ATTACHMENTS = `${CONVERSATION_ITEM}/attachments`;

// RBAC Permission endpoints
export const CONVERSATION_MEMBER_ROLE = `${CONVERSATION_ITEM_MEMBER}/role`;
export const CONVERSATION_MEMBER_PERMISSIONS = `${CONVERSATION_ITEM_MEMBER}/permissions`;
export const CONVERSATION_MEMBER_TRANSFER = `${CONVERSATION_ITEM_MEMBER}/transfer-ownership`;
export const CONVERSATION_MEMBER_OVERRIDES = `${CONVERSATION_ITEM_MEMBER}/:memberId/overrides`;

export const CONVERSATION_MESSAGE = `${CONVERSATION_ITEM}/messages`;
export const CONVERSATION_MESSAGE_BULK = `${CONVERSATION_MESSAGE}/bulk`;
export const CONVERSATION_MESSAGE_PINNED = `${CONVERSATION_MESSAGE}/pinned`;
export const CONVERSATION_MESSAGE_ITEM = `${CONVERSATION_MESSAGE}/:messageId`;
export const CONVERSATION_MESSAGE_ITEM_PIN = `${CONVERSATION_MESSAGE_ITEM}/pin`;
export const CONVERSATION_MESSAGE_ITEM_PINNED_REMOVE = `${CONVERSATION_MESSAGE_ITEM}/pin`;

// Message Reactions
export const CONVERSATION_MESSAGE_ITEM_REACTIONS = `${CONVERSATION_MESSAGE_ITEM}/reactions`;

// Message Status
export const CONVERSATION_MESSAGE_ITEM_STATUS = `${CONVERSATION_MESSAGE_ITEM}/status`;
export const CONVERSATION_MESSAGE_STATUS_DELIVERED_ACK = `${CONVERSATION_MESSAGE}/status/delivered/ack`;
export const CONVERSATION_MESSAGE_ITEM_STATUS_DELIVERED = `${CONVERSATION_MESSAGE_ITEM}/status/delivered`;
export const CONVERSATION_MESSAGE_ITEM_STATUS_READ = `${CONVERSATION_MESSAGE_ITEM}/status/read`;

export const CONVERSATION_CONTACT = `${USER_SER}/contacts`;
export const CONVERSATION_CONTACT_FRIENDS_WITH_PRESENCE = `${CONVERSATION_CONTACT}/friends-with-presence`;

// Search Service
export const SEARCH_SER = '/search-service/api/v1';
export const SEARCH_CONVERSATIONS = `${SEARCH_SER}/search/conversations`;
export const SEARCH_MESSAGES = `${SEARCH_SER}/search/messages`;
